import type { Point3D, VertexAttribute } from '../../../../types'
import { createIndexBufferUint32, updateAttributeBuffer } from '../../../../utils'

const FRAGMENT_INDEXES_COUNT = 6

export const updateBuffers = (
  renderingContext: WebGL2RenderingContext,
  positionsAttribute: VertexAttribute,
  offsetAttribute: VertexAttribute,
  points: Point3D[][],
) => {
  const verticies: Point3D[] = []
  const indices: number[] = []
  const offsets: number[] = []

  let indexesCount = 0

  for (const linePoints of points) {
    const fragmentsCount = linePoints.length - 1
    indexesCount += Math.max(fragmentsCount * FRAGMENT_INDEXES_COUNT, 0)
    for (let index = 0; index < fragmentsCount; index++) {
      const point0 = linePoints[index]
      const point1 = linePoints[index + 1]

      const left0Index = verticies.length
      const left1Index = verticies.length + 1
      const right0Index = verticies.length + 2
      const right1Index = verticies.length + 3

      verticies.push(point0)
      verticies.push(point0)
      verticies.push(point1)
      verticies.push(point1)

      const offsetX = point1.x - point0.x
      const offsetY = point1.y - point0.y
      offsets.push(offsetX, offsetY, 1)
      offsets.push(offsetX, offsetY, -1)
      offsets.push(offsetX, offsetY, 1)
      offsets.push(offsetX, offsetY, -1)

      indices.push(left0Index)
      indices.push(left1Index)
      indices.push(right0Index)
      indices.push(left1Index)
      indices.push(right1Index)
      indices.push(right0Index)
    }
  }

  updateAttributeBuffer(
    renderingContext,
    positionsAttribute,
    new Float32Array(verticies.flatMap(coord => [coord.x, coord.y, coord.z])),
  )
  const indexBuffer = createIndexBufferUint32(renderingContext, indices)

  updateAttributeBuffer(renderingContext, offsetAttribute, new Float32Array(offsets))
  return { indexBuffer, indexesCount }
}
